









import { Component } from 'vue-property-decorator'
import { EventDescription } from "frontend-common";
import ChooseEventImage from "@/components/dashboard/common/ChooseEventImage.vue";
import cr from "@/CompositionRoot";
import ToastMixin from "@/utils/ToastMixin";
import EventCoverImage from "@/components/dashboard/EventCoverImage.vue";
import EventLogoImage from "@/components/dashboard/EventLogoImage.vue";
import EventPrimaryColor from "@/components/dashboard/EventPrimaryColor.vue";
import EventOgImage from "@/components/dashboard/EventOgImage.vue";

@Component({
    components: {
        EventOgImage,
        EventPrimaryColor,
        EventLogoImage,
        EventCoverImage,
        ChooseEventImage
    }
})
export default class extends ToastMixin {

    get uuid(): string {
        return this.$route.params.uuid
    }

    get eventDescription(): EventDescription {
        return cr.myEventsModule.descriptionByUuid(this.uuid)!!
    }
}
